const ITEMS = ["Rooms & Suites", "The Sutra Spa", "Garden Dining", "Infinity Pool", "Weddings & Celebrations", "Nature Trails", "Weekend Escapes"];

export const Marquee = () => (
  <div className="marquee" data-testid="editorial-marquee" aria-hidden="true">
    <div className="marquee-track">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span className="marquee-item" key={i}>
          <em>{item}</em>
          <i>·</i>
        </span>
      ))}
    </div>
  </div>
);
